var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",class:{
    'modal-card': _vm.modal,
    'is-hovered': _vm.isHovered,
    'admin-view': _vm.adminView,
  }},[(_vm.displayRightContent)?_c('div',{staticClass:"right-content"},[_c('h3',[_vm._v(_vm._s(_vm.rightContentText))])]):_vm._e(),(_vm.title !== '')?_c('div',{class:{
      'card-top': true,
      'medcenter-modal': _vm.patientType === 'medcenter',
      'modal-top': _vm.modal,
    }},[(_vm.title !== '')?_c('BaseHeader',{attrs:{"type":"h2","no-margin":""}},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_vm._t("action"),(_vm.modal)?_c('a-icon',{attrs:{"type":"close"},on:{"click":function($event){return _vm.$emit('toggleModal')}}}):_vm._e()],2):_vm._e(),_c('div',{staticClass:"slot-content",class:{ titled: _vm.title }},[_vm._t("default")],2),_vm._t("loader")],2)}
var staticRenderFns = []

export { render, staticRenderFns }